import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { serviceApi } from '~/features';
import { SponsoredProductsReportsFilterDto } from '~/types';

export const DOWNLOAD_SPONSORED_PRODUCTS_REPORTS_FILTER_MUTATION_KEY =
  'DOWNLOAD_SPONSORED_PRODUCTS_REPORTS_FILTER_MUTATION';

async function exportSponsoredProductsExcel(
  params: SponsoredProductsReportsFilterDto
) {
  return serviceApi.get<Blob>(`/ReportProdutoPatrocinado/Filter-Export`, {
    params,
    responseType: 'blob',
  });
}

export function useDownloadSponsoredProductsReportsFilter(
  onSuccess?: (
    data: AxiosResponse<Blob, unknown>,
    variables: SponsoredProductsReportsFilterDto,
    context: SponsoredProductsReportsFilterDto
  ) => unknown,
  onError?: (
    error: Error,
    variables: SponsoredProductsReportsFilterDto,
    context: SponsoredProductsReportsFilterDto | undefined
  ) => unknown
) {
  return useMutation({
    mutationKey: [DOWNLOAD_SPONSORED_PRODUCTS_REPORTS_FILTER_MUTATION_KEY],
    mutationFn: async (params: SponsoredProductsReportsFilterDto) =>
      exportSponsoredProductsExcel(params),
    onSuccess,
    onError,
  });
}
